import React from 'react';
import { Clock, Brain, BookOpen } from 'lucide-react';

export default function WhatIsADP() {
  const cards = [
    { Icon: Clock, text: <>É o mais completo <strong>TREINAMENTO</strong> em <strong>MATEMÁTICA OLÍMPICA</strong> do Brasil para <strong>TODAS</strong> as fases!</> },
    { Icon: Brain, text: <>É o método <strong>DEFINITIVO</strong> (e cientificamente validado) que criou <strong>CENTENAS</strong> de <strong>MEDALHISTAS</strong> de TODOS os níveis!</> },
    { Icon: BookOpen, text: <>É uma <strong>COMUNIDADE</strong> em que <strong>MILHARES</strong> de alunos se dedicam a alcançar a <strong>EXCELÊNCIA</strong> em <strong>MUITAS OLIMPÍADAS CIENTÍFICAS</strong>.</> },
  ];
  return (
    <section className="gradient-bg-light py-24">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="text-[#a020c9] tracking-widest text-sm font-semibold uppercase">— Conheça —</p>
        <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-[#7a1fb0] mt-2 mb-14">
          O que é a Academia<br className="md:hidden"/> De Pitágoras?
          <div className="h-1 w-24 bg-[#ec2fd2] mx-auto mt-4 rounded"></div>
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {cards.map((c, i) => (
            <div key={i} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="flex justify-center mb-4">
                <div className="icon-bubble"><c.Icon size={30} /></div>
              </div>
              <p className="text-[#3a1450] leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
